import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IReportRequest, IReportResponse, IReturnSummaryByMT } from '../models/models'

export class GetOrderReportByMtApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/returnReport/ReturnReportsByMT',
      requesterInfo,
    })
  }

  public async getReport(req: IReportRequest): Promise<IReturnSummaryByMT[]> {
    return await this.postAsync<IReturnSummaryByMT[]>(req)
  }
}
